var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientMarketingCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 250,
    viewBox: "0 0 400 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0.25H375C388.669 0.25 399.75 11.331 399.75 25V225C399.75 238.669 388.669 249.75 375 249.75H25C11.331 249.75 0.25 238.669 0.25 225V25C0.25 11.331 11.331 0.25 25 0.25Z",
    fill: "black",
    stroke: "url(#paint0_linear_324_1290)",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M219.475 22H27.4749C-18.9251 22 17.1416 45.6667 40.9749 57.5C65.6416 63.8333 116.075 91.3 120.475 150.5C124.875 209.7 204.975 191.833 244.475 175.5C243.975 151.333 243.275 95.4 244.475 65C245.675 34.6 228.308 23.6667 219.475 22Z",
    fill: "url(#paint1_linear_324_1290)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_324_1290",
    x1: 32.5,
    y1: 32,
    x2: 203.062,
    y2: 316.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_324_1290",
    x1: 101.475,
    y1: 22.5,
    x2: 282.475,
    y2: 132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientMarketingCard);
export default __webpack_public_path__ + "static/media/gradient-marketing-card.a720183c2387bb5f57e6ec3910cf9eec.svg";
export { ForwardRef as ReactComponent };